import script from "./SankeyFlowChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SankeyFlowChart.vue?vue&type=script&setup=true&lang=js"

import "./SankeyFlowChart.vue?vue&type=style&index=0&id=26097ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26097ad8"]])

export default __exports__